import { type IntlShape } from 'react-intl'

import {
  directContactFormSubjectPolicyGetByTranslatedSubject,
  directContactFormSubjectPolicyGetImageUploadRequirement,
} from '../../direct-contact'

export const directContactFormAccessorIsImageUploadMandatory = ({
  intl,
  selectedProductTotalCost,
  subject,
}: {
  intl: IntlShape
  selectedProductTotalCost: number
  subject: string
}): boolean => {
  const { policy } = directContactFormSubjectPolicyGetByTranslatedSubject({
    intl,
    subject,
  })

  return (
    directContactFormSubjectPolicyGetImageUploadRequirement({
      imageUploadPolicy: policy.directPageImageUpload,
      isLoggedIn: true,
      selectedProductTotalCost,
    }) === 'required'
  )
}
